let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eQIEO")).then(() => parcelRequire('h4y14'));